module.exports = Object.freeze({
  CAREGIVER: 1,
  PATIENT: 2,
  FAMILY: 3,
  FRIEND: 4,
  SUPERVISOR: 5,
  CHAMPION: 0,
});
